import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $toasts, toastClosed } from '../../entities/toast';
import { Toast, ToastViewport } from '../../shared/ui';

export function Toaster() {
  const { t } = useTranslation();
  const [toasts, close] = useUnit([$toasts, toastClosed]);
  return (
    <>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          tone={toast.tone}
          {...(toast.action ? { action: toast.action } : {})}
          closeLabel={t('common.dismiss')}
          onOpenChange={(open) => {
            if (!open) close(toast.id);
          }}
        />
      ))}
      <ToastViewport label={t('shell.notifications')} />
    </>
  );
}
